export function createSlidingDoorMaterial(source, slide) {
  const material = source.clone()
  // Defines survive Stage's material clone and distinguish the GPU program even
  // when CSM wraps every onBeforeCompile callback in the same function.
  material.defines = { ...material.defines, SARATOGA_SLIDING_DOOR: 1 }
  const previousCompile = source.onBeforeCompile
  material.onBeforeCompile = function (shader, renderer) {
    previousCompile?.call(this, shader, renderer)
    shader.uniforms.doorSlide = slide
    shader.vertexShader = 'uniform float doorSlide;\n' + shader.vertexShader
    shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>',
      '#include <begin_vertex>\ntransformed.x += doorSlide;')
  }
  return material
}
